// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.wildlife-zone-manager {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 50;
}
.wildlife-zone-manager__window {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  position: relative;
  width: 920px;
  max-width: 94%;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
}
.wildlife-zone-manager__window * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .wildlife-zone-manager__window {
    animation: none;
  }
}
.wildlife-zone-manager__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.wildlife-zone-manager__header-buttons {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.wildlife-zone-manager__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.wildlife-zone-manager__body {
  display: flex;
  gap: 20px;
  flex: 1;
  min-height: 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.wildlife-zone-manager__list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  width: 240px;
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.wildlife-zone-manager__list::-webkit-scrollbar {
  width: 6px;
}
.wildlife-zone-manager__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.wildlife-zone-manager__list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-left: 2px solid transparent;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.wildlife-zone-manager__list-item:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
}
.wildlife-zone-manager__list-item:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.wildlife-zone-manager__list-item--selected {
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.07);
  border-left-color: var(--gold-main);
}
.wildlife-zone-manager__list-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wildlife-zone-manager__detail {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-right: 4px;
}
.wildlife-zone-manager__detail::-webkit-scrollbar {
  width: 6px;
}
.wildlife-zone-manager__detail::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.wildlife-zone-manager__section {
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.wildlife-zone-manager__section--danger-zone {
  border-bottom: 0;
  padding-bottom: 0;
}
.wildlife-zone-manager__label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  display: block;
  margin-bottom: 8px;
}
.wildlife-zone-manager__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.wildlife-zone-manager__input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: auto;
  padding: 7px 10px;
}
.wildlife-zone-manager__input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.wildlife-zone-manager__input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.wildlife-zone-manager__meta {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-top: 8px;
}
.wildlife-zone-manager__species-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  margin-top: 8px;
}
.wildlife-zone-manager__species-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #ebe8e1;
  cursor: pointer;
}
.wildlife-zone-manager__species-item input {
  width: 16px;
  height: 16px;
  accent-color: var(--gold-main);
}
.wildlife-zone-manager__confirm-text {
  font-size: 14px;
  color: #d9786d;
}
.wildlife-zone-manager__empty {
  padding: 12px 0;
  font-size: 14px;
  color: #8d8a82;
}
.wildlife-zone-manager__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.wildlife-zone-manager__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.wildlife-zone-manager__button:active:not(:disabled) {
  transform: translateY(1px);
}
.wildlife-zone-manager__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.wildlife-zone-manager__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.wildlife-zone-manager__button--small {
  padding: 5px 10px;
  font-size: 13px;
}
.wildlife-zone-manager__button--secondary {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.wildlife-zone-manager__button--secondary:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.wildlife-zone-manager__button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.wildlife-zone-manager__button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/WildlifeZoneManager/WildlifeZoneManager.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yDDeU;ECdV,WAAA;AAMF;AAJE;EDeA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECzJE,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAYJ;ADLE;EAAI,sBAAA;ACQN;ADqIE;EC9JA;ID8J0C,eAAA;ECjI1C;AACF;AAjBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAmBJ;AAhBE;EACE,aAAA;EACA,QAAA;EACA,iBAAA;AAkBJ;AAfE;EDYA,kDA3BW;EA4BX,gBAAA;EACA,eCbqB;EDcrB,iBAAA;EACA,sBAAA;EACA,cAxCK;AC8CP;AAnBE;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,iBAAA;EACA,+CAAA;AAqBJ;AAlBE;ED4GA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC5GE,YAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,iDAAA;AAsBJ;ADkFE;EAAuB,UAAA;AC/EzB;ADgFE;EAA6B,oCAAA;EAAsC,kBAAA;AC5ErE;AA1BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,yDD3CQ;EC4CR,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDvDK;ECwDL,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,yDAAA;AA4BJ;AA1BI;EAAU,cDhEP;ECgEyB,qCDpEnB;ACkGb;AA7BI;EAAkB,oCAAA;EAAsC,oBAAA;AAiC5D;AA/BI;EACE,wBAAA;EACA,qCAAA;EACA,mCAAA;AAiCN;AA7BE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA+BJ;AA5BE;EDgEA,gBAAA;EACA,qBAAA;EACA,qDAAA;EChEE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAgCJ;AD6BE;EAAuB,UAAA;AC1BzB;AD2BE;EAA6B,oCAAA;EAAsC,kBAAA;ACvBrE;AApCE;EACE,oBAAA;EACA,kDAAA;AAsCJ;AApCI;EACE,gBAAA;EACA,iBAAA;AAsCN;AAlCE;ED5CA,eAAA;EACA,gBAAA;EACA,cAzDO;ECqGL,cAAA;EACA,kBAAA;AAsCJ;AAnCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAqCJ;AAlCE;EDGA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECTE,WAAA;EACA,iBAAA;AA4CJ;ADlCE;EAAU,aAAA;EAAe,8BAAA;ACsC3B;ADrCE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC4C1G;AApDE;EDrEA,eAAA;EACA,gBAAA;EACA,cAlDO;ECuHL,eAAA;AAwDJ;AArDE;EACE,aAAA;EACA,gDAAA;EACA,aAAA;EACA,eAAA;AAuDJ;AApDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDxIG;ECyIH,eAAA;AAsDJ;AApDI;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AAsDN;AAlDE;EACE,eAAA;EACA,cDjJK;ACqMT;AAjDE;EACE,eAAA;EACA,eAAA;EACA,cDxJK;AC2MT;AA9CE;EDhGA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACiJF;AD/IE;EAAyB,qCAAA;EAAuC,8BAAA;ACmJlE;ADlJE;EAA0B,0BAAA;ACqJ5B;ADpJE;EAAa,YAAA;EAAc,mBAAA;ACwJ7B;ADvJE;EAAkB,oCAAA;EAAsC,mBAAA;AC2J1D;AA5EI;EDnDF,iBAAA;EACA,eAAA;ACkIF;AA/EI;ED5DF,cArGO;EAsGP,uBAAA;EACA,yBAAA;AC8IF;AD5IE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACiJhF;AAxFI;EDrEF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACgKF;AD9JE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACkQT","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Wildlife zone manager: centred ink window, zone list on the left, detail\n// sections on the right separated by headings and spacing.\n\n.wildlife-zone-manager {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 50;\n\n  &__window {\n    @include ink.panel;\n    @include ink.enter;\n    pointer-events: auto;\n    position: relative;\n    width: 920px;\n    max-width: 94%;\n    max-height: 86vh;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 24px;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 14px;\n  }\n\n  &__header-buttons {\n    display: flex;\n    gap: 8px;\n    margin-left: auto;\n  }\n\n  &__title {\n    @include ink.title(24px);\n  }\n\n  &__body {\n    display: flex;\n    gap: 20px;\n    flex: 1;\n    min-height: 0;\n    padding-top: 14px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__list {\n    @include ink.scroll;\n    width: 240px;\n    flex: none;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding-right: 14px;\n    border-right: 1px solid ink.$line;\n  }\n\n  &__list-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    font-family: ink.$font-text;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: left;\n    color: ink.$text-2;\n    background: transparent;\n    border: 0;\n    border-left: 2px solid transparent;\n    border-radius: 0 ink.$radius ink.$radius 0;\n    cursor: pointer;\n    transition: background-color 0.12s ease, color 0.12s ease;\n\n    &:hover { color: ink.$text; background: ink.$ink-raised; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n    &--selected {\n      color: var(--gold-light);\n      background: rgba(255, 255, 255, 0.07);\n      border-left-color: var(--gold-main);\n    }\n  }\n\n  &__list-item-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__detail {\n    @include ink.scroll;\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    padding-right: 4px;\n  }\n\n  &__section {\n    padding-bottom: 18px;\n    border-bottom: 1px solid ink.$line;\n\n    &--danger-zone {\n      border-bottom: 0;\n      padding-bottom: 0;\n    }\n  }\n\n  &__label {\n    @include ink.label;\n    display: block;\n    margin-bottom: 8px;\n  }\n\n  &__inline {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  &__input {\n    @include ink.field;\n    width: auto;\n    padding: 7px 10px;\n  }\n\n  &__meta {\n    @include ink.hint;\n    margin-top: 8px;\n  }\n\n  &__species-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px 16px;\n    margin-top: 8px;\n  }\n\n  &__species-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: ink.$text;\n    cursor: pointer;\n\n    input {\n      width: 16px;\n      height: 16px;\n      accent-color: var(--gold-main);\n    }\n  }\n\n  &__confirm-text {\n    font-size: 14px;\n    color: ink.$danger;\n  }\n\n  &__empty {\n    padding: 12px 0;\n    font-size: 14px;\n    color: ink.$text-3;\n  }\n\n  // Neutral by default, --secondary is the quiet tertiary kind, --danger for\n  // destructive actions.\n  &__button {\n    @include ink.button;\n\n    &--small { @include ink.button-sm; }\n    &--secondary { @include ink.button-quiet; }\n    &--danger { @include ink.button-danger; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
